export default __webpack_public_path__ + "static/media/25.804267be.jpg";